import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { AppConfigService } from 'src/app/services/app-config.service';

@Component({
  selector: 'app-tcn-chat',
  templateUrl: './tcn-chat.component.html',
  styleUrls: ['./tcn-chat.component.scss']
})
export class TcnChatComponent implements OnInit, AfterViewInit {
  @ViewChild('scriptContainer') scriptContainerRef!: ElementRef;

  constructor(@Inject(DOCUMENT) private document: Document, private appConfigService: AppConfigService) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const apiKey = this.appConfigService.getConfig()?.defaultConfiguration?.tcnChatApiKey;

    if (!_.isNil(apiKey))
    {
    const script = this.document.createElement('script');
    const content = this.document.createTextNode('    (function (n, t, e) { var a = t.createElement("script"); a.src = "https://operator.tcn.com/chat-client/main.js"; a.async = true; a.addEventListener("load", r); var i = t.getElementsByTagName("script")[0]; i.parentNode.insertBefore(a, i); function r() { if (typeof n.tcnChat.init === "function") { n.tcnChat.init(e) } } })(window, document, { apiKey: "' + apiKey + '", url: "chat.aus.tcn.com", mainColor: "#669EB4", headingColor: "#ffffff", paragraphColor: "#000000" });');
    script.appendChild(content);

    this.scriptContainerRef.nativeElement.appendChild(script);
    }
  }
}
